



function bootstrapCollapse(cl, cle) {

    $(cl).collapse(cle);
}

window.bootstrapCollapse = bootstrapCollapse;


export {bootstrapCollapse}
